// Holiday Mode: persist the dispatch-delay acknowledgement to a cart attribute
// as soon as it's ticked/unticked, so it's recorded on the order even for the
// cart drawer (which checks out via a plain link, not a form submission).
document.addEventListener('change', function (evt) {
  if (!evt.target.matches('.holiday-mode-checkbox')) return;

  var checked = evt.target.checked;

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      attributes: {
        'Holiday Dispatch Acknowledged': checked ? evt.target.value : ''
      }
    })
  });

  // Keep any other Holiday Mode checkboxes on the page (page + drawer can both
  // be present) in sync so the customer doesn't have to tick twice.
  document.querySelectorAll('.holiday-mode-checkbox').forEach(function (box) {
    if (box !== evt.target) box.checked = checked;
  });
});
